import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './plugins/i18n';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store, persistor } from './plugins/store';
import AppThemeProvider from './plugins/app-theme-provider';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import TimeAgo from 'javascript-time-ago';
import vi from 'javascript-time-ago/locale/vi';
import { GoogleOAuthProvider } from '@react-oauth/google';
TimeAgo.addDefaultLocale(vi);
TimeAgo.addLocale(vi);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
        <GoogleOAuthProvider
            clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ''}
        >
            <QueryParamProvider adapter={ReactRouter6Adapter}>
                <Provider store={store}>
                    <PersistGate loading={null} persistor={persistor}>
                        <AppThemeProvider>
                            <I18nextProvider i18n={i18n}>
                                <App />
                            </I18nextProvider>
                        </AppThemeProvider>
                    </PersistGate>
                </Provider>
                <ToastContainer />
            </QueryParamProvider>
        </GoogleOAuthProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
